import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import Aura from '@primeuix/themes/aura'
import 'primeicons/primeicons.css'

import App from './App.vue'
import { router } from './router'

import './styles.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(PrimeVue, {
  unstyled: false,
  theme: {
    preset: Aura,
    options: { darkModeSelector: '.dark-mode' },
  },
  ripple: true,
})
app.use(ToastService)
app.mount('#app')
